<template>
  <span>
    <input
      style="display: inline-block; max-width: 50px; padding: 5px;"
      @input="updateInput($event)"
      type="number"
      min="0"
      name="sort_order"
      v-model="sort_output.sort_order"
    />
  </span>
</template>
<script>
export default {
  name: "WeekDaySortInput",
  props: {
    entryId: {
      type: Number,
      default: null
    },
    sortOrder: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      sort_output: {
        entry_id: this.entryId || null,
        sort_order: this.sortOrder || 0
      }
    };
  },
  methods: {
    updateInput: function(event) {
      this.sort_output.entry_id = this.entryId;
      this.sort_output.sort_order = parseInt(event.target.value);
      this.$emit("updateSortOrder", this.sort_output);
    }
  }
};
</script>